import { Box, Paper, Stack } from '@mui/material'
import AppearanceColorSwatchRow from '@/components/Settings/AppearanceColorSwatchRow'
import appearanceStyles from '@/components/Settings/AppearanceSettingsContent.module.scss'
import { PreferenceFloatingSelect } from '@/components/Settings/SettingsPreferenceSection'
import { TEXT_HIGHLIGHT_OPTIONS } from '@/components/Settings/appearanceConstants'
import { SettingsRowLabelBlock } from '@/components/Settings/settingsRowLabelBlock'
import SettingsSectionIntro from '@/components/Settings/SettingsSectionIntro'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import shared from '@/components/Settings/settingsShared.module.scss'

/**
 * @param {{
 *   headingId: string, paperFirst: string, paperLast: string,
 *   accentColor: string, onAccentColorChange: (v: string) => void,
 *   textHighlight: string, onTextHighlightChange: (v: string) => void,
 * }} props
 */
export function AppearanceThemeSection({ headingId, paperFirst, paperLast, accentColor, onAccentColorChange, textHighlight, onTextHighlightChange }) {
  const highlightMenuOptions = TEXT_HIGHLIGHT_OPTIONS.map((o) => ({ value: o.value, label: o.label }))
  return (
    <Stack component="section" spacing={1.25} className={shared.preferenceSection} aria-labelledby={headingId}>
      <SettingsSectionIntro headingId={headingId} lines={getSettingsSectionIntro('theme')} />
      <Stack spacing={0} className={shared.preferenceSectionRows}>
        <Paper elevation={0} className={paperFirst}>
          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" className={appearanceStyles.appearanceRow}>
            <SettingsRowLabelBlock title="Colour" hideDescription />
            <AppearanceColorSwatchRow value={accentColor} onChange={onAccentColorChange} />
          </Stack>
        </Paper>
        <Paper elevation={0} className={paperLast}>
          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', sm: 'center' }} className={appearanceStyles.appearanceRow}>
            <SettingsRowLabelBlock title="Text highlight colour" hideDescription />
            <Box className={appearanceStyles.highlightRowControls}>
              <PreferenceFloatingSelect aria-label="Text highlight colour" value={textHighlight} options={highlightMenuOptions} onChange={onTextHighlightChange} />
            </Box>
          </Stack>
        </Paper>
      </Stack>
    </Stack>
  )
}
